export const ALL_SUBJECTS_STRING = 'Question Banks';
